import {Component, Input} from '@angular/core';
import {
  AdditionalSolution
} from '@app/checkout/additional-required-solutions-button/additional-required-solutions-modal/additional-required-solutions-modal.component';
import {Product} from '@spartacus/core';
import {DcpPriceData} from '@dcp/configurator';

@Component({
  selector: 'dcp-derivative-prices',
  templateUrl: './derivative-prices.component.html',
  styleUrls: ['./derivative-prices.scss']
})
export class DerivativePricesComponent {
  @Input() derivativePrice: string;
  @Input() supplierAlternativeIdCount: number;
  @Input() subtotalPrice: any;
  @Input() product: Product;
  @Input() orderEntriesOneParent: AdditionalSolution[] = [];
  @Input() priceData: DcpPriceData;
  isDerivativesModalOpened: boolean = false;

  openDerivativesModal() {
    this.isDerivativesModalOpened = true;
  }
}
